import BaseService from "./geral/BaseService";
const base = "OcupacaoPatio";

export default class OcupacaoPatioService extends BaseService {
    constructor(isSSA) {
        super(base);
    }

    recuperaOcupacaoTecon(){
        return super.httpGet(`/${base}/RecuperaOcupacaoTecon`, false);
    }

    recuperaOcupacaoDepot(){
        return super.httpGet(`/${base}/RecuperaOcupacaoDepot`, false);
    }

    recuperaIconeAtivo(){
        return super.httpGet(`/${base}/RecuperaIconeAtivo`, false);
    }

   
}


// WEBPACK FOOTER //
// ./src/services/OcupacaoPatioService.js